document.addEventListener('DOMContentLoaded', () => {
  const snowContainer = document.createElement('div');
  document.body.appendChild(snowContainer);

  const createSnowflake = () => {
    const snowflake = document.createElement('div');
    snowflake.classList.add('snowflake');
    snowflake.textContent = "❅";

    snowflake.style.left = Math.random() * window.innerWidth + 'px';
    snowflake.style.fontSize = (Math.random() * 16 + 10) + 'px';
    snowflake.style.animationDuration = (Math.random() * 5 + 5) + 's';

    snowContainer.appendChild(snowflake);

    setTimeout(() => snowflake.remove(), 10000);
  };

  setInterval(createSnowflake, 200);
});
